import React from "react";
import { PAGES, PERMISSION_DATA } from "../../../lib/const";
import usePermission from "../../../lib/hooks/usePermisson";
import Content from "./components/content";
import Search from "./components/search";
import SearchFutureCustomerPersonaProvider from "./searchContext";
import WithSidebar from "../../../templates/withSidebar";
const DashboardFutureCustomerPersona = () => {
    const [roleUser, isAll] = usePermission(
        PERMISSION_DATA.APPLICATION,
        PAGES.FUTURE_CUSTOMER
      );
  return (
    <SearchFutureCustomerPersonaProvider>
      <Search roleUser={roleUser} />
      <Content roleUser={roleUser} />
    </SearchFutureCustomerPersonaProvider>
  );
};

export default DashboardFutureCustomerPersona;
